<template>
    <AntTable
        ref="table"
        row-key="id"
        :loading="loading"
        :data-source="data"
        :columns="columns"
        :pagination="pagination"
        v-bind="$attrs"
        @change="handleTableChange"
    >
        <div
            slot="filterDropdown"
            slot-scope="{
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
                column
            }"
            style="padding: 8px"
        >
            <AntInput
                v-ant-ref="c => (searchInput = c)"
                :placeholder="$t('searchBy', { field: column.title.toLowerCase() })"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block;"
                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="handleSearch(column.dataIndex, selectedKeys, confirm)"
            />
            <AntButton
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="handleSearch(column.dataIndex, selectedKeys, confirm)"
            >
                {{ $t('search') }}
            </AntButton>
            <AntButton
                size="small"
                style="width: 90px"
                @click="handleClearFilters(column.dataIndex, clearFilters)"
            >
                {{ $t('reset') }}
            </AntButton>
        </div>
        <Icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
        />
    </AntTable>
</template>

<script>
import { Table, Icon, Button, Input } from 'ant-design-vue';
export default {
    name: 'Table',
    components: {
        AntTable: Table,
        Icon,
        AntButton: Button,
        AntInput: Input,
    },
    props: {
        /**
         * Used to indicate if the table is in a loading state
         */
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        /**
         * The rows used to render the table
         */
        data: {
            type: Array,
            required: true,
        },
        /**
         * Pagination data
         */
        pagination: {
            type: Object,
            required: false,
            default: () => {},
        },
        /**
         * The columns to render
         */
        columns: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            filters: {},
        };
    },
    methods: {
        /**
         * Called when the state of table changes eg pagination, filters, sort.
         */
        handleTableChange(pagination, antFilters, antSort) {
            this.$emit('change', {
                pagination: this.formatPagination(pagination),
                filters: this.formatFilters(this.filters),
                sort: this.formatSort(antSort),
            });
        },
        /**
         * Formats the pagination to a format usuable by the API
         */
        formatPagination(pagination) {
            return {
                page: pagination.current,
                pageSize: pagination.pageSize,
            };
        },
        /**
         * Formats the pagination to a format usuable by the API
         */
        formatSort(sort) {
            return sort.field
                ? (sort.order === 'ascend' ? '' : '-') + sort.field
                : null;
        },
        /**
         * Formats the filter to a format usuable by the API
         */
        formatFilters(filters) {
            const formattedFilter = {};

            Object.keys(filters).forEach(
                key => (formattedFilter[`filter[${key}]`] = filters[key]),
            );

            return formattedFilter;
        },
        /**
         * Handles when the reset button is clicked in a filter
         */
        handleClearFilters(key, clear) {
            delete this.filters[key];

            // Function passed through from ant that closes the filter dialog and empties the input
            clear();
        },
        /**
         * Handles when the search button is clicked in a filter
         */
        handleSearch(key, value, close) {
            if (!value[0]) {
                return this.handleClearFilters(key, close);
            }

            this.filters[key] = value[0];

            // Function passed through from ant that closes the filter dialog
            close();
        },
    },
};
</script>

<style></style>
